import React, { Component } from 'react'
import { connect } from 'react-redux'

import classnames from 'classnames';
import '@/companys/ttl/assets/styles/components/detail-center/news.scss';

import { stockActions } from '@/actions/trading/stock.action';
import { ACTION_TYPE, NEWS_TYPE } from "@/constants/w-socket";
import { WS_LANG_KEY } from '@/constants/app';
import { utilsFunction, Converter } from "@/helpers/functions";
import moment from 'moment';
import { settingConfigs } from '@/configurations';
import LoadingLayer from '@/components/Spinner/LoadingLayer';
import { LOADING_TYPE } from '@/constants/app';

import { openNewsDetailDialog } from '@/actions/app/dialog.action'
import NoRow from '@/components/DataTable/CustomNoRow';

 class Announcement extends Component {
    constructor(props){
        super(props)
        this.state = {
            AnnouncementData : [],
            load:false
        }
    }
    render() {
        const { AnnouncementData, load } = this.state;
        return (
            <React.Fragment>
                <div className={classnames('news-container-ttl')}>
                <LoadingLayer load={load} type={LOADING_TYPE.BIG_IMG} />
                    {
                    !load && Array.isArray(AnnouncementData) && AnnouncementData.length == 0 && <NoRow style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }} />
                    }
                    <section>
                        {AnnouncementData.map((Announcements, index) =>
                        <div onClick={() => openNewsDetailDialog(AnnouncementData, Announcements.id,'marker_announcement')} key={Announcements.id + index} className="item">
                        <span className="stock-code">[ {Announcements.source} ]</span>
                        <span className="title">{Announcements.headline}</span>
                        <span className="time">{moment(Announcements.releaseTime).format(settingConfigs.LONG_DATE)}</span>
                    </div>)}
                    </section>
                </div>
            </React.Fragment>
        )
    }
    componentDidMount(){
      this.props.innerRef(this)
        this.getAnnouncementData()
    }
    componentDidUpdate(prevProps, prevState) {
        const { marketParams } = this.props;
        const { marketID, stockCode } = marketParams;
        // if(Number(10000)<=Number(stockCode) && Number(stockCode)<=20000 && marketID ==='HKEX' || !stockCode) return;
        if (marketParams && marketParams !== prevProps.marketParams) {
          if (utilsFunction.instrumentIDZeroPadding(stockCode) !== utilsFunction.instrumentIDZeroPadding(prevProps.marketParams.stockCode)) {
            this.getAnnouncementData()
          }
        }
      }
    componentWillUnmount() {
        this.setState = (state, callback) => {
          return
        }
      }
    getAnnouncementData(){
        this.setState({load:true,AnnouncementData:[]})
        const { language, marketParams } = this.props;
        let marketID = null
        let stockCode = null
        if(this.props.marketParams.stockCode < 10000 || this.props.marketParams.stockCode > 29999){
            marketID = this.props.marketParams.marketID
            stockCode = this.props.marketParams.stockCode
        }else {
          if(!this.props.NCmarketParams.NCmarketID || !this.props.NCmarketParams.NCstockCode) return
            marketID = this.props.NCmarketParams.NCmarketID
            stockCode = this.props.NCmarketParams.NCstockCode
        }
        if (!(marketID && stockCode)){
          this.setState({
            AnnouncementData: []
          })
          return
        } 
        const params = {
            subscribe: null,
            msgType: ACTION_TYPE.NEWS,
            category: NEWS_TYPE.ANNOUNCEMENT,
            datetime: moment().format(settingConfigs.LONG_DATE),
            count: 20,
            symbols: [
              {
                exchangeID: Converter.mappingWebSocketMarket(marketID),
                key: Converter.mappingStockCode(stockCode)
              }
            ],
            language: language.lang !== 'zh_CN' ? utilsFunction.switchToolTipsLanguage(language, WS_LANG_KEY.EN, WS_LANG_KEY.SC, WS_LANG_KEY.TC) : WS_LANG_KEY.TC
          }
        this.props.getAnnouncement(params,res => {
          if (res.rtnCode) { this.setState({load:false}); return}
            let data = this.state.AnnouncementData;
            if (data.length == 0) {
                data.push(res)
              }else {
                if (data.findIndex(item => item.id == res.id) == -1) {
                  data.push(res)
                }
              }
            this.setState({AnnouncementData:data,load:false})
        })
    }
}


export default connect( state =>({
    language: state.app.language,
    marketParams: state.trade.marketParams,
    NCmarketParams:state.trade.NCmarketParams,
}), dispatch => ({
    getAnnouncement:(p, c) => stockActions.getNewsAction(p, c)
}))(Announcement)